<template>
	<v-app>
		<loading :active.sync="getIsLoading" :can-cancel="false" :is-full-page="true" loader="dots" color="#007BFF"> </loading>

		<dialog-yes-no ref="DialogYesNo" />
		<dialog-info ref="DialogInfo" />
		<dialog-info-web ref="DialogInfoWeb" />

		<v-navigation-drawer app fixed v-model="drawer" v-if="userAuthorized && wizardFinish">
			<v-list-item>
				<v-list-item-avatar>
					<v-img src="logo.png"></v-img>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title class="title"> AP-Logistics </v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-divider />

			<v-list-item link to="/profile" v-if="userAuthorized">
				<v-list-item-icon>
					<v-icon>mdi-card-account-details-outline</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					{{ getUser.email }}
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

			<v-list-item v-for="item in mainMenu" :key="item.title" :disabled="item.title === ''" @click="menuItemClickHandler(item)">
				<v-list-item-icon v-if="item.title !== ''">
					<v-icon color="primary">{{ item.icon }}</v-icon>
				</v-list-item-icon>

				<v-list-item-content v-if="item.title !== ''">
					<v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
				</v-list-item-content>

				<v-divider v-if="item.title == ''"></v-divider>
			</v-list-item>
		</v-navigation-drawer>

		<v-app-bar app color="primary" dark>
			<v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="userAuthorized && wizardFinish" />
			<v-toolbar-title class="headline text-uppercase">
				<span>AP</span>
				<span class="font-weight-light">Logistics | {{ pageName }}</span>
			</v-toolbar-title>
			<v-spacer />

			<template v-slot:extension v-if="tabsAppBarVisible">
				<v-tabs v-model="getCurrentTicketTab" @change="setTab">
					<v-tab v-for="tab in tabsAppBar" :key="tab.title">
						{{ tab.title }}
					</v-tab>
				</v-tabs>
			</template>

			<v-menu bottom left v-if="!wizardFinish">
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>

				<v-list>
					<v-list-item v-for="(item, i) in toolbarMenu" :key="i" @click="menuItemClickHandler(item)">
						<v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
		<v-main>
			<!--  -->
			<v-dialog v-model="getMessageDialog.trigger" width="500" transition="dialog-bottom-transition" persistent scrollable>
				<v-card>
					<v-toolbar color="primary" dark
						>{{ getMessageDialog.title }}
						<v-spacer></v-spacer>
						<v-btn icon @click="copyToClipBoard(getMessageDialog.description)">
							<v-icon>mdi-content-copy</v-icon>
						</v-btn>
					</v-toolbar>
					<v-card-text>
						<div class="mt-4">{{ getMessageDialog.description }}</div>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn text @click="closeMessageDialog()">{{ getMessageDialog.buttonTitle }}</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!--  -->
			<StartWizard v-if="!wizardFinish && !appInit" />
			<router-view v-if="wizardFinish" />
		</v-main>

		<template>
			<div class="text-center">
				<v-bottom-sheet v-model="getToastMessage" inset>
					<v-sheet class="text-center">
						<v-btn @click.native="setToastMessage({ message: null })" class="mt-2" text color="primary">{{ $t("common.button_close") }}</v-btn>
						<div class="pb-4">{{ getToastMessage }}</div>
					</v-sheet>
				</v-bottom-sheet>
			</div>
		</template>
	</v-app>
</template>

<script>
import Loading from "vue-loading-overlay"
import "vue-loading-overlay/dist/vue-loading.css"
import DialogInfo from "@/components/dialogs/common/DialogInfo"
import DialogYesNo from "@/components/dialogs/common/DialogYesNo"
import DialogInfoWeb from "@/components/dialogs/common/DialogInfoWeb.vue"

import { mapActions, mapGetters, mapMutations } from "vuex"
import StartWizard from "@/components/StartWizard.vue"

export default {
	name: "App",

	components: { StartWizard, DialogYesNo, Loading, DialogInfo, DialogInfoWeb },

	data: () => ({
		drawer: false,
		tabModel: undefined,
		appInit: true,
	}),
	computed: {
		...mapGetters("common", [
			"getIsLoading",
			"getMessageDialog",
			// "getToastMessage",
			"getUser",
			"getUserProps",
		]),

		...mapGetters("app", ["getWorkStatus", "getCurrentTicketTab", "getReportsTypes"]),

		wizardFinish() {
			const operation = localStorage.getItem("operation") === "started"
			const status = this.getWorkStatus.status > 4 && operation
			return status
		},
		getToastMessage() {
			return this.$store.getters.getToastMessage
		},

		tabsAppBarVisible() {
			if (this.$route.name === "MyTicketsPage" || this.$route.name === "ProfilePage" || this.$route.name === "MyReportsPage") {
				return true
			}
			return false
		},

		// fabVisible(){
		//   if (this.$route.name === 'MyTicketsPage'){
		//     return true
		//   }
		//   return false
		// },

		tabsAppBar() {
			if (this.$route.name === "MyTicketsPage") {
				return this.$t("TicketsPage.tabs")
			} else if (this.$route.name === "ProfilePage") {
				return this.$t("ProfilePage.tabs")
			} else if (this.$route.name === "MyReportsPage") {
				const reportsTypes = this.getReportsTypes
				console.log("reportsTypes", reportsTypes)
				return reportsTypes.map((item) => ({ title: item.name }))
			} else return []
		},

		userAuthorized() {
			return window.keycloak.authenticated
		},

		toolbarMenu() {
			let menu = []
			menu.push({ title: "menu.exit", icon: "mdi-exit-to-app", url: undefined, func: this.logout })
			console.log(menu)
			return menu
		},

		mainMenu() {
			let menu = []

			menu.push({ title: "menu.main", icon: "mdi-home", url: { name: "MainPage" }, func: undefined })
			// menu.push({ title: "menu.myProps", icon: "mdi-account-details", url: { name: "MyPropsPage", func: undefined  } },)
			// menu.push({ title: "menu.myLocations", icon: "mdi-map-marker", url: { name: "MyLocationsPage" }, func: undefined  },)
			menu.push({ title: "menu.myReports", icon: "mdi-file-document-multiple", url: { name: "MyReportsPage" }, func: undefined })
			menu.push({ title: "menu.myTickets", icon: "mdi-account-arrow-right", url: { name: "MyTicketsPage" }, func: undefined })
			menu.push({ title: "menu.myInBox", icon: "mdi-account-arrow-left", url: { name: "MyInboxPage" }, func: undefined })

			menu.push({ title: "menu.help", icon: "mdi-help-circle", url: undefined, func: this.openNotesExt })
			// menu.push({ title: "menu.help", icon: "mdi-help-circle", url: undefined, func: this.openNotes },)
			menu.push({ title: "", icon: "", url: { name: "" } })

			menu.push({ title: "menu.exit", icon: "mdi-exit-to-app", url: undefined, func: this.logout })

			//menu.push({ title: "Contract", icon: "mdi-file-document-multiple", url: { name: "ContractPage" }, func:undefined },)
			//menu.push({ title: "Contract", icon: "mdi-file-document-multiple", url: { path: "contract" }, func:undefined },)
			//TODO DEBUG Убрать
			// menu.push({ title: "echo", icon: "mdi-bug", url: undefined, func: this.echo },)
			// menu.push({ title: "menu.settings", icon: "mdi-cog-outline", url: { name: "SettingsPage" },})
			// menu.push({ title: "menu.debug", icon: "mdi-bug", url: { name: "DebugPage" } })

			// menu.push({ title: "Debug", icon: "mdi-file-document-multiple", url: { name: "DebugPage" }, func:undefined },)

			return menu
		},

		pageName() {
			let pageTitle = ""
			try {
				pageTitle = this.$t("pages").find((item) => item.name === this.$route.name).title
			} catch (e) {
				console.log("pageTitle error", e)
			}
			return pageTitle
		},

		currentPage() {
			return this.$route.name
		},
	},
	methods: {
		...mapActions("common", [
			"loadUserFromLocalStorage",
			"apiBackendLogout",
			"apiBackendSetProps",
			"apiBackendGetProps",
			"closeMessageDialog",
			"copyToClipBoard",
		]),
		...mapActions("app", ["apiUserGetInfo", "apiGetTickets", "apiGetMessages", "apiGetMetaInfo", "apiGetReportsFiles"]),

		...mapMutations("common", ["setToastMessage", "setUser", "setIsLoading"]),
		...mapMutations("app", ["setCurrentTicketTab"]),

		async openNotesExt() {
			window.open("https://space.aptrade.ru/upload/learning/Manuals/APLogistics/index.html?poryadok_raboty_pri_formirovanii_zayavok.htm", "_blank")
		},

		async openNotes() {
			//https://subtitletools.com/convert-text-files-to-utf8-online
			const result = await this.$refs.DialogInfoWeb.show({
				title: "Памятка по работе в личном кабинете",
				src: `/static/Памятка%20о%20порядке%20работы.htm`,
				positiveTitle: "Ознакомился",
			})
			console.log(result)
		},

		setTab(tab) {
			console.log("setTab", tab)
			this.setCurrentTicketTab(tab)
		},

		async logout() {
			//console.log('logout')
			const result = await this.$refs.DialogYesNo.show({
				title: this.$t("dialogs.logout.title"),
				message: this.$t("dialogs.logout.message"),
				negative: this.$t("common.button_cancel"),
				positive: this.$t("common.button_yes"),
			})
			if (result.answer === "positive") {
				//console.log('logout...')
				await this.apiBackendLogout()
			}
		},

		menuItemClickHandler(item) {
			if (item.url !== undefined) {
				this.$router.push(item.url).catch((failure) => {
					console.log("route errer", failure)
				})
			}
			if (item.func !== undefined) {
				item.func()
			}
		},

		// async echo(){
		//    //console.log('UI command echo')
		//    //await this.apiBackendEcho({field:"Hello world"})
		// },
	},
	watch: {
		// getUserProps: {
		//   handler(newVal, oldVal) {
		//     console.log('newVal',newVal)
		//     console.log('oldVal',oldVal)
		//   },
		//   deep: true,
		// },

		// tabModel(value, oldValue){
		//   console.log('old', oldValue)
		//   console.log('tabModel',value)
		//   this.setCurrentTicketTab(value)
		// },

		getUserProps(userProps) {
			console.log("user props change")
			let language = userProps["language"]
			let theme = userProps["theme"]

			if (language === null || language === undefined) {
				language = "ru"
			}
			if (theme === null || theme === undefined) {
				theme = "light"
			}

			this.$vuetify.theme.dark = theme === "dark"
			this.$i18n.locale = language
		},

		currentPage(routeName) {
			let pageTitle = this.$t("pageTitlePrefix") + " | " + this.$t("pages").find((item) => item.name === routeName).title
			//console.log('page title: '+pageTitle)
			document.title = pageTitle
		},

		getToastMessage(val) {
			if (val !== null) {
				setTimeout(() => this.setToastMessage({ message: null }), 5000)
			}
		},
	},
	provide() {
		return {
			appRefs: this.$refs,
		}
	},
	created() {
		this.setUser({ email: window.keycloak.tokenParsed.email })

		this.setIsLoading(true)
		this.apiUserGetInfo().finally(() => {
			// console.log('update status',this.getWorkStatus.status)
			this.setIsLoading(false)
			this.appInit = false
		})

		this.apiGetMetaInfo()

		this.apiBackendGetProps()
		// this.echo()

		this.apiGetTickets({
			date1: "",
			date2: "",
			locations: [],
			statuses: [],
		}),
			this.apiGetReportsFiles({
				date1: "",
				date2: "",
				locations: [],
				reportsTypes: [],
			}),
			this.apiGetMessages({
				date1: "",
				date2: "",
				locations: [],
				statuses: [],
			})

		console.log("getUserProps in create::", this.getUserProps)

		let pageTitle = this.$t("pageTitlePrefix") + " | " + this.$t("pages").find((item) => item.name === this.$route.name).title
		document.title = pageTitle
	},
	mounted() {},
}
</script>

<style lang="css">
.v-tabs-slider-wrapper,
.v-tab--active {
	color: #fff !important;
}
</style>
